import { render, staticRenderFns } from "./zid.vue?vue&type=template&id=88ec8d56"
import script from "./zid.vue?vue&type=script&lang=js"
export * from "./zid.vue?vue&type=script&lang=js"
import style0 from "./zid.vue?vue&type=style&index=0&id=88ec8d56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports